import { gsap } from "gsap/gsap-core";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const defaultIntensity = 10;

// Cache intensity calculations to avoid repeated regex operations
const intensityCache = new WeakMap();

function getIntensity(element) {
	if (intensityCache.has(element)) {
		return intensityCache.get(element);
	}

	const classes = element.className.split(' ');
	const parallaxClass = classes.find(cls => /^parallax-\d+$/.test(cls));
	let intensity;

	if (!parallaxClass) {
		intensity = defaultIntensity / 100;
	} else {
		const parsedIntensity = parseInt(parallaxClass.split('-')[1]);
		intensity = (isNaN(parsedIntensity) ? defaultIntensity : parsedIntensity) / 100;
	}

	intensityCache.set(element, intensity);
	return intensity;
}

export function setupParallaxElements() {
	// Get all elements with .parallax class
	const parallaxElements = document.querySelectorAll('.parallax');

	// Loop through each element
	parallaxElements.forEach(parallaxElement => {
		// Create a tween for the image
		gsap.to(parallaxElement, {
			scrollTrigger: {
			  trigger: parallaxElement,
			  start: "top bottom", // Start when element's top hits bottom of viewport
			  end: "bottom top",   // End when element's bottom hits top of viewport
			  scrub: true,         // Smooth scrubbing effect
			  onUpdate: (self) => {
				// Calculate the center point
				const elementRect = parallaxElement.getBoundingClientRect();
				const elementCenter = elementRect.top + elementRect.height / 2;
				const windowCenter = window.innerHeight / 2;

				// Calculate distance from center (in pixels)
				const distanceFromCenter = elementCenter - windowCenter;

				// Apply the translation
				gsap.set(parallaxElement, {
				  y: distanceFromCenter * getIntensity(parallaxElement)
				});
			  }
			}
		  });
	});
}

export function setupParallaxElementOverflow(repeat = false) {
	// Get all elements with .parallax class
	const parallaxElements = document.querySelectorAll('.parallax');

	// Cache window dimensions
	const windowHeight = window.innerHeight;
	const windowCenter = windowHeight / 2;

	// Loop through each element
	parallaxElements.forEach(parallaxElement => {
		// Calculate the center point
		const elementRect = parallaxElement.getBoundingClientRect();
		const elementCenter = windowHeight + elementRect.height / 2;

		// Calculate distance from center (in pixels)
		const distanceFromCenter = elementCenter - windowCenter;

		const overflowMax = distanceFromCenter * getIntensity(parallaxElement);
		parallaxElement.style.setProperty('--parallax-overflow', `${overflowMax}px`);
	});

	if (repeat) {
		window.requestAnimationFrame(() => setupParallaxElementOverflow());
	}
}

